import { useMutation, useQueryClient } from '@tanstack/react-query'
import { deleteOverrideRule } from '../../../api/plan-benefit-override-rules-api'
import { OVERRIDE_RULES_QUERY_KEY } from '../pages/ListPlanBenefitOverride/hooks/useGetOverrideRules'

export function useDeleteOverrideRule() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (id: string) => deleteOverrideRule(id),
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: [OVERRIDE_RULES_QUERY_KEY] })
    },
  })
}
